<script lang="ts">
	export let title = '';
	export let description = '';
  export let align: 'left' | 'center' | 'right' = 'left';
</script>

<div class={`twm-alert twm-alert--align-${align}`}>
  <slot>
    {#if title}
    <h5 class="twm-alert__title">{title}</h5>
    {/if}
    {#if description}
    <p class="twm-alert__description">{description}</p>
    {/if}
  </slot>
</div>

<style lang="scss">

  .twm-alert {
    background: #EEEEF5;
    padding: 14px 16px;
    border-radius: 12px;

    &--align-left {
      text-align: left;
    }

    &--align-center {
      text-align: center;
    }

    &--align-right {
      text-align: right;
    }

    &__title + &__description {
      margin-top: 4px;
    }

    &__title {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: #1A1D26;
      letter-spacing: -0.02em;
    }

    &__description {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: #626262;
      letter-spacing: -0.02em;
    }
  }
</style>
